<div class="footer">
    <div class="icons-container">
        <icon class="footer-icon facebook" src="Footer_Facebook" (click)="redirectToFacebook()" [width]="40" [height]="40"></icon>
        <icon class="footer-icon gmail" src="Footer_Gmail" (click)="redirectToGmail()" [width]="40" [height]="40"></icon>
    </div>
</div>